import { API_URL } from 'constants/api';
import type { CreatedPass } from '../types';
import { api } from './api';


const CREATED_PASS_URL = `${API_URL}/templates/created_passes`

export const createdPassApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listCreatedPasses: builder.query<CreatedPass[], void>({
      query: () => `${CREATED_PASS_URL}/`,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ serial_number }) => ({ type: 'CreatedPasses' as const, id: serial_number })),
              { type: 'CreatedPasses', id: 'LIST' },
            ]
          : [{ type: 'CreatedPasses', id: 'LIST' }],
    }),
    retrieveCreatedPasses: builder.query<CreatedPass, string>({
      query: (id) => `${CREATED_PASS_URL}/${id}/`,
      providesTags: (result, error, id) => result ? [{ type: 'CreatedPasses', id: result.serial_number }] : [{ type: 'CreatedPasses', id: 'LIST' }],
    }),
    retrieveCreatedPassBySerial: builder.query<CreatedPass, string>({
      query: (sn) => `${CREATED_PASS_URL}/get_pass_by_sn/?serial_number=${sn}`,
      providesTags: (result, error, sn) => [{ type: 'CreatedPasses', id: sn }],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useListCreatedPassesQuery, useRetrieveCreatedPassBySerialQuery, useLazyRetrieveCreatedPassBySerialQuery, useLazyRetrieveCreatedPassesQuery } = createdPassApi